import App from './App.vue';

export default {
  path: '/CDS_VF_LifelineRailwayDetail',
  name: 'CDS_VF_LifelineRailwayDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'ライフライン(鉄道)',
      controller: 'CDS_CTR_LifelineRailwayDetail',
    },
  },
};
